import GravityLayout from './GravityLayout';

export default GravityLayout;
